import { useUserContext } from 'contexts/UserContext';

import { VerifyTooltip } from 'components/PageWrappers/SharedComponents/VerifyTooltip/VerifyTooltip';
import { Button } from 'components/Toolkit/Button/Button';

import { useRevealDealerEnquiryModal } from 'components/PageWrappers/SharedComponents/RevealDealerEnquiryModal/RevealDealerEnquiryModal.hook';
import type { RevealDealerEnquiryModalProps } from 'components/PageWrappers/SharedComponents/RevealDealerEnquiryModal/RevealDealerEnquiryModal.typed';

function RevealDealerEnquiryModal(props: RevealDealerEnquiryModalProps) {
  const {
    adId,
    size = 'SMALL',
    testId = 'reveal-send-message',
    trackingId,
    clickSource = '',
    text = 'Make an Enquiry',
    disabled = false,
    id,
    ofType = 'PRIMARY',
  } = props;
  const { user } = useUserContext();

  const userIsNotMinimumVerified = Boolean(user && !user.isMinimumVerified);

  const { handleReveal, directUserToSigninPage } = useRevealDealerEnquiryModal({
    adId,
    clickSource,
  });

  return (
    <>
      {userIsNotMinimumVerified ? (
        <VerifyTooltip
          arrowPosition={['right', 'right', 'center']}
          tooltipPosition={'above'}
        >
          <Button
            size={size}
            data-testid={testId}
            data-tracking={trackingId}
            disabled={disabled}
            id={id}
            ofType={ofType}
          >
            {text}
          </Button>
        </VerifyTooltip>
      ) : (
        <Button
          size={size}
          onClick={user ? handleReveal : directUserToSigninPage}
          data-testid={testId}
          data-tracking={trackingId}
          disabled={disabled}
          id={id}
          ofType={ofType}
        >
          {text}
        </Button>
      )}
    </>
  );
}

export { RevealDealerEnquiryModal };
